import * as React from "react";
import * as S from "@styled";
import { AuthOptions, BaseHttpTriggerConfig, HttpTriggerBase } from "./HttpTrigger";

import { Spec } from "swagger-schema-official";
import { InputMode } from "./TriggerInput";
import { TypedTriggerInput } from "./TypedTriggerInput";

import ApiSpecOperationSelector from "./ApiSpecOperationSelector";

import * as AppPath from "../../model/AppPath";
import MonacoEditor from "../../../shared/monaco/components/MonacoEditor";
import { ParameterEditorMode } from "../ParameterInput";
import { ISimpleApiSpecificationData } from "apiManagement/model/model";

const TriggerInput = TypedTriggerInput as new () => TypedTriggerInput<HttpApiTriggerConfig>;

export const HttpApiTrigger: React.FC<HttpApiTriggerProps> = (props) => {

    if (!props.existingParameters.apiSpec && !props.existingParameters.openApiDocument) {
        return <ApiSpecOperationSelector id={props.id} />;
    }

    const getApiSpecLink = () => {
        const foundApiSpec = props.apiSpecs?.find((x) => x.name.toLowerCase() === ((props.existingParameters.apiSpec && props.existingParameters.apiSpec.basePath) || props.existingParameters.basePath).toLowerCase())
        if (foundApiSpec) {
            return <S.OpenExternalLink
                href={AppPath.getApiManagementLink(foundApiSpec.id)}
            >
                {FRENDS.Localizations.OpenApiSpec} <i className="ci-external_link" />
            </S.OpenExternalLink>
        }
        return <S.WarningContainer><div className="alert alert-info no-margin" role="alert">
            API Specification not found
        </div></S.WarningContainer>

    }
    return (
        <div>
            <S.FormGroup style={{ textAlign: "right" }}>
                {getApiSpecLink()}
            </S.FormGroup>
            <HttpTriggerBase
                id={props.id}
                disableInputsFromSwagger={true}
                existingParameters={props.existingParameters}
                authOptions={AuthOptions}
            />
            <TriggerInput
                parameters={props.existingParameters}
                parameterName="isPrivate"
                label={FRENDS.Localizations.PrivateHttpTriggerLabel}
                inputMode={InputMode.boolean}
                elementId={props.id}
            />
            {props.existingParameters.openApiDocument ?
                <S.FormGroup>
                    <S.Label>
                        OpenApi Document
                    </S.Label>
                    <S.ExpressionEditorContainer>
                        <MonacoEditor
                            value={props.existingParameters.openApiDocument}
                            key={"apiSpec_editor"}
                            readOnly={true}
                            mode={props.existingParameters.openApiDocument.startsWith("{") ? ParameterEditorMode.json : ParameterEditorMode.yaml}
                        />
                    </S.ExpressionEditorContainer>
                </S.FormGroup>
                :
                <S.FormGroup>
                    <S.Label>
                        Swagger
                    </S.Label>
                    <S.ExpressionEditorContainer>
                        <MonacoEditor
                            value={JSON.stringify(props.existingParameters.apiSpec, null, "\t")}
                            key={"apiSpec_editor"}
                            readOnly={true}
                            mode={ParameterEditorMode.json}
                        />
                    </S.ExpressionEditorContainer>
                </S.FormGroup>}
        </div>
    );
};

interface HttpApiTriggerProps {
    id: string;
    apiSpecs: ISimpleApiSpecificationData[] | null;
    existingParameters: BaseHttpTriggerConfig & HttpApiTriggerConfig;
}

export interface HttpApiTriggerConfig extends BaseHttpTriggerConfig {
    apiSpec?: Spec;
    isPrivate: boolean;
    references: string[];
    openApiDocument: string;
    basePath: string;
}
